import styled from 'styled-components';
import { Form } from '@iterable/deprecated_react_components';
import { pxToRem } from 'utils/convert';

// @ts-ignore
export const StyledCoreFormGroup = styled(Form.Group)`
  &&& {
    display: flex;
    width: 100%;
    > * {
      flex: 1 1 auto;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      label {
        width: 100%;
      }
      &:nth-of-type(2) {
        max-width: ${pxToRem(100)};
      }
      .ui.selection.dropdown {
        flex: 1 1 auto;
        min-width: 0;
        width: auto;
      }
    }
  }
`;
